<template>
  <div>
    <div v-if="connected" @click="clickButton()" class="shutdown">
      <div class="inner"></div>
      <div class="sub-bar"></div>
      <div class="bar"></div>
    </div>
    <div v-else class="loader-wrapper">
      <h3>Verbinde.. </h3>
      <div class="loader"></div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      connected: false
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
      this.connected = true
    },
    disconnect: function () {
      console.log('connection lost')
      this.connected = false
    }
  },
  methods: {
    clickButton: function () {
      // $socket is socket.io-client instance
      this.$socket.emit('messageType', 'test')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.shutdown {
    border: 8px solid #0cf;
    border-radius: 100px;
    box-shadow: 0 0 10px #0cf, inset 0 0 10px #0cf;
    height: 100px;
    width: 100px;
    margin: auto;
}

.shutdown .inner {
    border: 5px solid #0cf;
    border-radius: 100px;
    box-shadow: 0 0 10px #0cf, inset 0 0 10px #0cf;
    height: 30px;
    left: 30px;
    position: relative;
    top: 30px;
    width: 30px;
}

.shutdown .bar {
    border-left: 5px solid #0cf;
    box-shadow: 0 0 10px #0cf;
    height: 20px;
    left: 47px;
    position: relative;
    top: -15px;
    width: 0;
}

.shutdown .sub-bar {
    height: 30px;
    margin-left: 44px;
    margin-top: -20px;
    position: absolute;
    width: 0;
}

.loader {
  height: 4px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
}
.loader:before{
  display: block;
  position: absolute;
  content: "";
  left: -200px;
  width: 200px;
  height: 4px;
  background-color: #2980b9;
  animation: loading 2s linear infinite;
}

@keyframes loading {
    from {left: -200px; width: 30%;}
    50% {width: 30%;}
    70% {width: 70%;}
    80% { left: 50%;}
    95% {left: 120%;}
    to {left: 100%;}
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue